import { render } from "./account-password.vue?vue&type=template&id=ffa4edae&ts=true"
import script from "./account-password.vue?vue&type=script&lang=ts"
export * from "./account-password.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__